// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISpendLimitPeriodRemainingDto
 */
export interface ISpendLimitPeriodRemainingDto {
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitPeriodRemainingDto
     */
    spend_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitPeriodRemainingDto
     */
    remaining?: number;
}

/**
 * Check if a given object implements the ISpendLimitPeriodRemainingDto interface.
 */
export function instanceOfISpendLimitPeriodRemainingDto(value: object): value is ISpendLimitPeriodRemainingDto {
    return true;
}

export function ISpendLimitPeriodRemainingDtoFromJSON(json: any): ISpendLimitPeriodRemainingDto {
    return ISpendLimitPeriodRemainingDtoFromJSONTyped(json, false);
}

export function ISpendLimitPeriodRemainingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISpendLimitPeriodRemainingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'spend_limit': json['spend_limit'] == null ? undefined : json['spend_limit'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
    };
}

export function ISpendLimitPeriodRemainingDtoToJSON(json: any): ISpendLimitPeriodRemainingDto {
    return ISpendLimitPeriodRemainingDtoToJSONTyped(json, false);
}

export function ISpendLimitPeriodRemainingDtoToJSONTyped(value?: ISpendLimitPeriodRemainingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spend_limit': value['spend_limit'],
        'remaining': value['remaining'],
    };
}

